























import {Component, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/DialogMixins';

@Component({
  inheritAttrs: false,
})
export default class AskConfirmationDialog extends Mixins(DialogMixin) {
  routeName!: string;

  confirmAnswer = '';

  text = '';

  onOk() {
    this.$emit('answer', true);
    return this.close();
  }

  open(text: string, confirmAnswer: string) {
    this.dialog = true;
    this.text = text;
    this.confirmAnswer = confirmAnswer;
  }
}
